<template>
    <div class="new-input-box">
        <el-form :model="ruleFormData" ref="ruleFormData" class="backgroundForm" label-width="140px">
          <div v-if="basicInformation">
            <jd-title label='基本信息' type="bold" ></jd-title>
             <el-form-item label="活动名称:" required >
                <!--  -->
                <el-input v-model="ruleFormData.activityName"  maxlength="50" show-word-limit :disabled="isEdit || isEdits  ? false : disabled"
                    placeholder="请输入活动名称" style="width: 400px"></el-input>
             </el-form-item>
             <slot name="activityTimeslot" v-if="isShowActivityTimeSlot"></slot>
             <el-form-item label="活动时间:" required  v-else>
                <div class="my_select_time">
                    <el-date-picker prefix-icon="no_icon" v-model="activityStartTime" type="datetime" placeholder="开始日期"
                        size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 185px; font-size: 12px" class="time1" @change="activityTimeChange"
                        :picker-options="pickerOptionsValue"
                        :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                        :clearable="false" :disabled="disabled">
                    </el-date-picker>
                    <div class="time_to_text">至</div>
                    <!--  -->
                    <el-date-picker prefix-icon="no_icon" v-model="activityEndTime" type="datetime" placeholder="结束日期"
                        size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 200px; font-size: 12px" class="time2" @change="activityTimeChange"
                        @focus="orderFocus" :picker-options="pickerOptionsValueEnd"
                        :default-time="this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)"
                        :disabled="isEdit ? disabled : false"
                        :clearable="false" >
                    </el-date-picker>
                    <i class="el-icon-circle-close date_icon1" v-if="!disabled" @click="clearTime()"></i>
                    <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt=""
                        class="date_icon2" />
                </div>
                <span class="lastTime" style="color: #666">
                    活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天 <span style="color: #fe4d45">{{ timeOut
                        }}</span>
                    小时
                    <el-tooltip class="item" effect="light" content="活动时间不可超过互动数据授权有效期及店铺接入有效期" placement="bottom">
                        <el-button type="text" style="width: 35px;">
                            <i class="el-icon-question" style="color: #cccccc"></i>
                        </el-button>
                    </el-tooltip>
                </span>
                <div class="act-tip" v-if="isShowTip">
                    *提示：修改活动结束时间后，新增的活动时间范围的活动数据无法获取
                </div>
             </el-form-item>
            </div>
            <el-form-item label="活动对象:" prop="partner" v-if="isShowCondTarget">
                <el-radio v-if="isShowParterRadio" v-model="actMember" label="1" :disabled="disabled" @change="changeActMember">不限</el-radio>
                <el-radio v-if="isShowParterRadio" v-model="actMember" label="2" :disabled="disabled" @change="changeActMember">指定身份</el-radio>
                <el-radio v-if="isShowParterRadio" v-model="actMember" label="3" :disabled="disabled" @change="changeActMember">指定人群
                    <el-button style="margin-left:10px;" v-if="actMember == '3'"
                        @click="openCrowd">已选人群({{ peopleSelected.length }})</el-button>
                </el-radio>
                <el-radio v-model="actMember" label="4" :disabled="disabled" v-if="isNeedActMemberPurchased">已购非会员</el-radio>
                <div v-if="objExtraTip" class="extra-tip">{{ objExtraTip }}</div>
                <div v-if="actMember == '2'" class="user_condition">用户条件
                     <jd-button type="blueText" @click="isShowUserCondition = !isShowUserCondition">
                        {{isShowUserCondition?'收起':'展开'}}
                    </jd-button>
                </div>  
                <div class="rule_box" v-if="actMember == '2' && isShowUserCondition" style="padding: 10px 20px;">
                    <div v-if="actMember == '2' && isNeedCusType" style="display:flex;align-items: center;">
                        <span>新老客户：</span>
                        <el-radio-group v-model="ruleDTOCusType" @change="changeCusType">
                            <el-radio :label="0" :disabled="disabled">不限</el-radio>
                            <el-radio :label="1" :disabled="disabled">历史新客</el-radio>
                            <el-radio :label="2" :disabled="disabled">近365天新客</el-radio>
                            <el-radio :label="3" :disabled="disabled">老客</el-radio>
                        </el-radio-group>
                        <el-tooltip placement="top-start" effect="dark"
                            content="历史新客：用户在店铺下历史无有效订单;
                            近365天新客：用户在店铺下近365天内无有效订单;
                            老客：历史完成订单数大于等于1">
                            <template #content>
                                <div>
                                历史新客：用户在店铺下历史无已完成的订单（如店铺为多店品牌会员，则为品牌维度新客）
                                </div>
                                <div>
                                    近365天新客：用户在店铺下近365天内无有效订单（用户提单后即为有效订单，即使提单后未支付，在取消之前都属于有效）
                                </div>
                                <div>
                                    老客：历史完成订单数大于1
                                </div>
                            </template>
                            <div style="margin-left: 8px;">
                                新老客说明<i style="margin-left: 4px; color: #999" class="el-icon-question"></i>
                            </div>
                        </el-tooltip>
                    </div>
                    <div></div>
                    <div v-if="actMember == '2'" style="display:flex; height: 30px">
                        <span class="formTitle">会员等级：</span>
                        <el-checkbox-group v-model="ruleFormData.partner" @change="checkListchange" :disabled="disabled"
                            v-if="actMember == '2'">
                            <el-checkbox label="-1" name="partner">全部</el-checkbox>
                            <el-checkbox v-if="needNonMember" label="0" name="partner">非会员</el-checkbox>
                            <el-checkbox v-for="(item, index) in levelList" :key="index" :label="index + 1 + ''" name="partner" >{{ item }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <span v-if="actMember == '2' && activityId!= 63" class="ml-100" style="color:#F56C6C">{{ getCustomerTip() }}</span>
                    <!-- <div v-if="actMember == '2'" style="display:flex">
                        <span>入会时间：</span>
                        <el-checkbox v-model="ruleDTOIsCheckOpenCardTime"
                            :disabled="disabled">指定时间段</el-checkbox>
                        <div class="my_select_time" style="margin-left:8px">
                            <el-date-picker prefix-icon="no_icon" v-model="ruleDTOOpenCardStartTime"
                                type="datetime" placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss" style="width: 185px; font-size: 12px" class="time1"
                                :clearable="false" :disabled="!ruleDTOIsCheckOpenCardTime || disabled">
                            </el-date-picker>
                            <div class="time_to_text">至</div>
                            <el-date-picker prefix-icon="no_icon" v-model="ruleDTOOpenCardEndTime"
                                type="datetime" placeholder="结束日期" size="small" format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss" style="width: 200px; font-size: 12px" class="time2"
                                :picker-options="openCardEndTimeOptionsValue" :clearable="false"
                                :disabled="!ruleDTOIsCheckOpenCardTime || disabled">
                            </el-date-picker>
                            <i v-if="!disabled" class="el-icon-circle-close date_icon1" @click="clearNewTime"></i>
                            <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt=""
                                class="date_icon2" />
                        </div>
                    </div> -->
                    <div v-if="actMember == '2'" style="display:flex; height: 30px">
                        <span class="formTitle">首次入会时间：</span>
                         <el-radio-group v-model="ruleFormData.firstOpenCardTimeType">
                            <el-radio :label="0" :disabled="disabled">不限</el-radio>
                            <el-radio :label="1" :disabled="disabled">
                                <span  v-if="activityId!= 63" class="mr4">参与活动前</span>  
                                <span v-if="activityId== 63" class="mr4">弹窗前 </span>
                                <el-input v-model="ruleFormData.openCardBeforeDay" :disabled="ruleFormData.firstOpenCardTimeType !=1 || disabled"
                                    placeholder="请输入" style="width: 100px"></el-input>
                                    天入会
                            </el-radio>
                            <el-radio :label="2" :disabled="disabled">指定
                                <div class="my_select_time" style="margin-left:8px">
                                    <el-date-picker prefix-icon="no_icon" v-model="ruleDTOOpenCardStartTime"
                                        type="datetime" placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss" style="width: 185px; font-size: 12px" class="time1"
                                        :clearable="false" :disabled="ruleFormData.firstOpenCardTimeType !=2 || disabled">
                                    </el-date-picker>
                                    <div class="time_to_text">至</div>
                                    <el-date-picker prefix-icon="no_icon" v-model="ruleDTOOpenCardEndTime"
                                        type="datetime" placeholder="结束日期" size="small" format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss" style="width: 200px; font-size: 12px" class="time2"
                                        :picker-options="openCardEndTimeOptionsValue" :clearable="false"
                                        default-time="23:59:59"
                                        :disabled="ruleFormData.firstOpenCardTimeType !=2 || disabled ">
                                    </el-date-picker>
                                    <i v-if="!disabled" class="el-icon-circle-close date_icon1" @click="clearNewTime"></i>
                                    <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt=""
                                        class="date_icon2" />
                                </div>
                                <span class="ml8">期间入会</span>
                            </el-radio>
                        </el-radio-group>
                    </div>
                    <span v-if="actMember == '2'" class="ml-100" style="color:#F56C6C">注意：该条件对【非会员】身份不生效</span>
                    <span v-if="localStepNum == 3||localStepNum == 4">注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次</span>
                    <div  v-if="activityId!= 63">
                        <span class="formTitle">Plus会员身份：</span>
                        <el-radio-group v-model="ruleDTOPlusObject">
                            <el-radio :label="0" :disabled="disabled || plusObjectDistype">不限</el-radio>
                            <el-radio :label="1" :disabled="disabled || plusObjectDistype">Plus会员</el-radio>
                            <el-radio :label="2" :disabled="disabled || plusObjectDistype">非plus会员</el-radio>
                        </el-radio-group>
                        <div style="color:#F56C6C; line-height:30px" class="ml-100">
                            注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。
                        </div>                        
                    </div>
                </div>
                <!-- 满额有礼独有 -->
                <div v-if="actMember == '2' && isShowShopCondition && actTypes" class="condition-header">
                    <span class="condition-title">购物条件</span>
                    <jd-button type="blueText" class="toggle-btn" @click="isShopConditionExpanded = !isShopConditionExpanded">
                        {{ isShopConditionExpanded ? "收起" : "展开" }}
                    </jd-button>
                </div>
                <div v-if="actMember == '2' && isShopConditionExpanded && actTypes" class="shopContainer">
                    <!-- 累计完成订单笔数 -->
                    <div class="order-count-section">
                        <span class="shopLabel">累计完成订单笔数：</span>
                        <el-input class="order-input" :disabled="disabled" v-model="ruleFormData.orderCompleteLimitCount"
                            @input="
                                ruleFormData.orderCompleteLimitCount = getNumberData(
                                    2,
                                    $event,
                                    0,
                                    1
                                )
                                " placeholder="请输入"></el-input>
                        <span class="ml8-mr8">笔至</span>
                        <el-input class="order-input" v-model="ruleFormData.orderCompleteMaxCount" :disabled="disabled"
                            @input="
                                ruleFormData.orderCompleteMaxCount = getNumberData(2, $event, 0, 1)
                                " placeholder="请输入"></el-input><span class="ml8-mr8">笔</span>
                      <el-tooltip effect="light" placement="top" content="说明：累计完成订单笔数：该数据来源至【用户-会员列表】中用户的“交易成功笔数”数据">
                        <el-button type="text" style="width: 35px;">
                          <i class="el-icon-question" style="color: #ccc;"></i>
                        </el-button>
                      </el-tooltip>
                    </div>
                    <!-- 累计完成订单金额 -->
                    <div class="order-amount-section">
                        <span class="shopLabel">累计完成订单金额：</span>
                        <el-input class="order-input" :disabled="disabled" v-model="ruleFormData.orderCompleteLimitPayment"
                            @input="
                                ruleFormData.orderCompleteLimitPayment = getNumberData(
                                    2,
                                    $event,
                                    1,
                                    0
                                )
                                " placeholder="请输入"></el-input>
                        <span class="ml8-mr8">元至</span>
                        <el-input class="order-input" :disabled="disabled" v-model="ruleFormData.orderCompleteMaxPayment"
                            @input="
                                ruleFormData.orderCompleteMaxPayment = getNumberData(
                                    2,
                                    $event,
                                    1,
                                    0
                                )
                                " placeholder="请输入"></el-input><span class="ml8-mr8">元</span>
                      <el-tooltip effect="light" placement="top" content="说明：累计完成订单金额：该数据来源至【用户-会员列表】中用户的“交易成功金额”数据">
                        <el-button type="text" style="width: 35px;">
                          <i class="el-icon-question" style="color: #ccc;"></i>
                        </el-button>
                      </el-tooltip>
                    </div>
                
                    <div class="last-order-time-section">
                        <span class="shopLabel">最后一次订单完成时间：</span>
                        <el-radio v-model="ruleFormData.lastOrderCompleteTimeType" :label="0"
                            :disabled="disabled">不限</el-radio>
                        <el-radio v-model="ruleFormData.lastOrderCompleteTimeType" :label="1" :disabled="disabled">
                            <span class="mr8">距当前</span>
                            <el-input class="day-input" v-model="ruleFormData.lastOrderCompleteStartDay" @input="
                                ruleFormData.lastOrderCompleteStartDay = getNumberData(
                                    2,
                                    $event,
                                    0,
                                    1
                                )
                                " placeholder="请输入" :disabled="disabled || ruleFormData.lastOrderCompleteTimeType != '1'
                                "></el-input>
                            <span class="ml8-mr8">天至</span>
                            <el-input class="day-input" v-model="ruleFormData.lastOrderCompleteEndDay" @input="
                                ruleFormData.lastOrderCompleteEndDay = getNumberData(
                                    2,
                                    $event,
                                    0,
                                    1
                                )
                                " placeholder="请输入" :disabled="disabled || ruleFormData.lastOrderCompleteTimeType != '1'
                                "></el-input>
                            <span class="ml8">天</span></el-radio>
                        
                        <!-- 第三个单选框：指定时间期间 -->
                        <el-radio v-model="ruleFormData.lastOrderCompleteTimeType" :label="2" :disabled="disabled">指定
                            <div class="my_select_time">
                                <el-date-picker prefix-icon="no_icon" v-model="ruleFormData.lastOrderCompleteStartTime"
                                    style="width: 185px; font-size: 12px"
                                    type="datetime" placeholder="开始日期" size="small" format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss" class="time1 start-time-picker"
                                     :clearable="false" :disabled="disabled || ruleFormData.lastOrderCompleteTimeType != '2'
                                ">
                                </el-date-picker>
                                <div class="time_to_text">至</div>
                                <el-date-picker prefix-icon="no_icon" v-model="ruleFormData.lastOrderCompleteEndTime"
                                    style="width: 200px; font-size: 12px" :picker-options="lastOrderCompleteEndTimeOptionsValue"
                                    type="datetime" placeholder="结束日期" size="small" format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss" class="time2 end-time-picker" :disabled="disabled || ruleFormData.lastOrderCompleteTimeType != '2'
                                " :clearable="false">
                                </el-date-picker>
                                <i v-if="!disabled" class="el-icon-circle-close date_icon1" @click="clearOrderFinishTime"></i>
                                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt=""
                                    class="date_icon2" />
                            </div>
                            <span class="period-text ml8">期间</span>
                        </el-radio>
                    </div>
                </div>
                <div v-if="actMember == '2' && activityId== 46&&ruleDTOCusType==3" class="condition-header">
                    <span class="condition-title">下单条件</span>
                    <jd-button type="blueText" class="toggle-btn" @click="isOrderExpanded = !isOrderExpanded">
                        {{ isOrderExpanded ? "收起" : "展开" }}
                    </jd-button>
                </div>
               
                <div v-if="actMember == '2' && isOrderExpanded&&ruleDTOCusType==3" class="old-greyBg-overflow shopContainer">
                  <el-form-item label="最后付款时间：">
                    <el-checkbox
                      v-model="ruleFormData.orderCondition.isSelectLastPayTime"
                      :disabled="disabled"
                      @change="handleLastPayTimeChange"
                    >
                      指定最后一次付款时间范围
                    </el-checkbox>
                    <span class="tip-style">
                    勾选表示仅最后一次付款时间满足一下时间要求的老客方客参与
                    </span>
                    <div class="old-greyBg" v-if="ruleFormData.orderCondition.isSelectLastPayTime">
                      <el-form-item label="最后一次付款时间：">
                        <div class="my_select_time">
                          <el-date-picker
                            prefix-icon="no_icon"
                            v-model="ruleFormData.orderCondition.lastPayStartTime"
                            type="datetime"
                            placeholder="开始日期"
                            size="small"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            style="width: 185px; font-size: 12px"
                            class="time1"
                            :default-time="
                              this.$getDate(30)[0].substring(
                                11,
                                this.$getDate(30)[0].length
                              )
                            "
                            :clearable="false"
                            :disabled="disabled"
                            :picker-options="startPayPicker"
                          >
                          </el-date-picker>
                          <div class="time_to_text">至</div>
                          <el-date-picker
                            prefix-icon="no_icon"
                            v-model="ruleFormData.orderCondition.lastPayEndTime"
                            type="datetime"
                            placeholder="结束日期"
                            size="small"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            style="width: 200px; font-size: 12px"
                            class="time2"
                            :default-time="
                              this.$getDate(30)[0].substring(
                                11,
                                this.$getDate(30)[0].length
                              )
                            "
                            :clearable="false"
                            :picker-options="endpayPicker"
                          >
                          </el-date-picker>
                          <i
                            class="el-icon-circle-close date_icon1"
                            v-if="!disabled"
                            @click="clearLastOrderTime()"
                          ></i>
                          <img
                            src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                            alt=""
                            class="date_icon2"
                          />
                        </div>
                      </el-form-item>
                    </div>
                  </el-form-item>
                  <el-form-item label="购物条件：">
                    <el-checkbox
                      :disabled="disabled"
                      v-model="ruleFormData.orderCondition.isSelectOrder"
                      @change="handleOrderChange"
                    >
                      指定老客购物条件
                    </el-checkbox>
                    <span class="tip-style">
                    勾选则表示仅满足以下购物条件的老客可参与活动，按时间范围内累计订单统计
                    </span>
                    <div class="old-greyBg" v-if="ruleFormData.orderCondition.isSelectOrder">
                      <el-form-item label="下单时间：" required>
                        <span>用户在</span>
                        <div class="my_select_time mlr8">
                          <el-date-picker
                            prefix-icon="no_icon"
                            v-model="ruleFormData.orderCondition.orderStartTime"
                            type="datetime"
                            placeholder="开始日期"
                            size="small"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            style="width: 185px; font-size: 12px"
                            class="time1"
                            :default-time="
                              this.$getDate(30)[0].substring(
                                11,
                                this.$getDate(30)[0].length
                              )
                            "
                            :clearable="false"
                            :disabled="disabled"
                            :picker-options="startOrderPicker"
                          >
                          </el-date-picker>
                          <div class="time_to_text">至</div>
                          <el-date-picker
                            prefix-icon="no_icon"
                            v-model="ruleFormData.orderCondition.orderEndTime"
                            type="datetime"
                            placeholder="结束日期"
                            size="small"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            style="width: 200px; font-size: 12px"
                            class="time2"
                            :default-time="
                              this.$getDate(30)[0].substring(
                                11,
                                this.$getDate(30)[0].length
                              )
                            "
                            :clearable="false"
                            :picker-options="endOrderPicker"
                            :disabled="disabled"
                          >
                          </el-date-picker>
                          <i
                            class="el-icon-circle-close date_icon1"
                            v-if="!disabled"
                            @click="clearShopOrderTime()"
                          ></i>
                          <img
                            src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                            alt=""
                            class="date_icon2"
                          />
                        </div>
                        <span>期间内下单</span>&nbsp;
                      </el-form-item>
                      <el-form-item label="商品要求：" required>
                        <el-radio-group
                          v-model="ruleFormData.orderCondition.skuType"
                          :disabled="disabled"
                        >
                          <el-radio :label="0">全部商品</el-radio>
                          <el-radio :label="1">指定商品</el-radio>
                          <el-radio :label="2">排除商品</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item
                        v-show="ruleFormData.orderCondition.skuType != 0"
                        label="选择商品："
                        required
                      >
                        <jd-button
                          :disabled="
                            ruleFormData.orderCondition.skuType == 0 ||
                            disabled ||
                            showGoodsLoading
                          "
                          @click="handleOpenOldOrderWare"
                        >
                          选择商品（{{ orderWareList.length }}/100）
                        </jd-button>
                        <span
                          v-show="ruleFormData.orderCondition.skuType == 1"
                          class="goods-tip"
                          >指定时间段内购买指定商品即可参与活动</span
                        >
                        <el-select
                          v-show="ruleFormData.orderCondition.skuType == 2"
                          v-model="ruleFormData.orderCondition.excludeSkuType"
                          style="margin-left: 8px; width: 250px"
                          :disabled="disabled"
                        >
                          <el-option
                            v-for="item in appointOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        label="订单金额："
                        label-position="left"
                        required
                      >
                        <span class="mr8">大于等于</span>
                        <el-input
                          v-model="ruleFormData.orderCondition.minOrderAmt"
                          placeholder="请输入"
                          style="width: 100px"
                          @input="
                            ruleFormData.orderCondition.minOrderAmt = handleInput($event)
                          "
                          @blur="
                            ruleFormData.orderCondition.minOrderAmt =
                              formatOrderAmount($event)
                          "
                          :disabled="disabled"
                        ></el-input>
                        <span class="ml8">元</span>
                      </el-form-item>
                      <el-form-item label="商品件数：" label-position="left">
                        <span class="mr8">大于等于</span>
                        <el-input
                          v-model="ruleFormData.orderCondition.minItemCnt"
                          placeholder="请输入"
                          style="width: 100px"
                          @input="
                            ruleFormData.orderCondition.minItemCnt = getNumberData(
                              1,
                              $event,
                              0,
                              1
                            )
                          "
                          :disabled="disabled"
                        ></el-input>
                        <span class="ml8">件</span>
                      </el-form-item>
                      <el-form-item
                        required
                        label="订单状态："
                        label-position="left"
                      >
                        <el-radio-group
                          v-model="ruleFormData.orderCondition.orderType"
                          :disabled="disabled"
                        >
                          <el-radio :label="0">已付款</el-radio>
                          <el-radio :label="1">已完成</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </div>
                  </el-form-item>
                </div>
            </el-form-item>
            <el-form-item 
                label="非指定人群提示(主):" 
                label-width="150px"
                v-if="actMember == 3 && isShowCrowdTips" 
            >
                <el-input 
                    v-model="crowdTipMainText" 
                    :disabled="isCrowdTextDisabled"
                    @input="handlCorwdTips($event, 'crowdTipMainText')"
                    style="width: 420px;"
                    class="crowd-tip-main"
                    show-word-limit
                    :maxlength="15"
                    placeholder="活动仅限指定人群参与"
                ></el-input>
            </el-form-item>
            <el-form-item 
                label="非指定人群提示(辅):" 
                label-width="150px"
                v-if="actMember == 3 && isShowCrowdTips" 
            >
                <el-input 
                    v-model="crowdTipSubText" 
                    :disabled="isCrowdTextDisabled"
                    @input="handlCorwdTips($event, 'crowdTipSubText')"
                    class="crowd-tip-main"
                    style="width: 420px;"
                    show-word-limit
                    :maxlength="30"
                    placeholder="快去看看其他活动吧~"
                ></el-input>
            </el-form-item>
            <!-- <el-form-item label="Plus会员身份:" required>
                <el-radio-group v-model="ruleDTOPlusObject">
                    <el-radio :label="0" :disabled="disabled || plusObjectDistype">不限</el-radio>
                    <el-radio :label="1" :disabled="disabled || plusObjectDistype">Plus会员</el-radio>
                    <el-radio :label="2" :disabled="disabled || plusObjectDistype">非plus会员</el-radio>
                </el-radio-group>
                <div style="color:#F56C6C">
                    注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。
                </div>
            </el-form-item> -->
            <el-form-item label="活动条件:" v-if="isShowCondFollow">
                <el-checkbox label="关注店铺后方可参与活动" v-model="ruleFormData.condFollow" :disabled="isDisableCond"></el-checkbox>
                <el-checkbox :disabled="diaAbleOpenCardFollow||isDisableCond" label="开卡入会后方可参与活动" :true-label="1" :false-label="0" 
                    v-model="ruleFormData.openCardFollow">
                </el-checkbox>
                <el-checkbox label="屏蔽黑名单" v-if="disabled && ruleFormData.isValidBlackList == 1" v-model="ruleFormData.isValidBlackList" :true-label="1" :false-label="0" :disabled="disabled && ruleFormData.isValidBlackList == 1||isDisableCond"></el-checkbox>
                <el-checkbox v-else label="屏蔽黑名单" v-model="ruleFormData.isValidBlackList" :true-label="1" :false-label="0" :disabled="isDisableCond"></el-checkbox>
                <el-button type="text" style="color:#2768FF;" @click="openBlackListPage">设置黑名单</el-button>
                <el-tooltip content="说明：配置后，C端黑名单用户即使满足活动对象条件也不可参与活动" placement="top">
                    <i class="el-icon-question" style="color:#909399; cursor:pointer; margin-left:5px;"></i>
                </el-tooltip>
                
                <div v-if="showOpenCardTip" style="color:#F56C6C;">
                    注：为保证用户体验，请尽量确保用户入会后，能满足"活动对象"会员等级设置
                </div>
            </el-form-item>


            <!-- 单独屏蔽黑名单-->
             <el-form-item label="屏蔽黑名单:" v-if="isShowBlack">
                <el-checkbox v-if="disabled && ruleFormData.isValidBlackList == 1" label="屏蔽黑名单" v-model="ruleFormData.isValidBlackList" :true-label="1" :false-label="0" :disabled="disabled && ruleFormData.isValidBlackList == 1"></el-checkbox>
                <el-checkbox v-else label="屏蔽黑名单" v-model="ruleFormData.isValidBlackList" :true-label="1" :false-label="0"></el-checkbox>
                <el-button type="text" style="color:#2768FF;" @click="openBlackListPage">设置黑名单</el-button>
                <el-tooltip content="说明：配置后，C端黑名单用户即使满足活动对象条件也不可参与活动" placement="top">
                    <i class="el-icon-question" style="color:#909399; cursor:pointer; margin-left:5px;"></i>
                </el-tooltip>
             </el-form-item>

            <!-- 学生身份配置 -->
            <el-form-item label="学生身份:" v-if="isShowStudentSet">
                <el-checkbox
                    v-model="studentSet"
                    :true-label="1"
                    :false-label="0"
                    :disabled="disabled"
                    @change="onStudentSetChange"
                >不限</el-checkbox>
                <el-checkbox-group
                    v-model="studentSatusArr"
                    :disabled="disabled"
                    style="display:inline-block;margin-left:10px;"
                >
                    <el-checkbox
                        v-for="item in studentStatusList"
                        :key="item.value"
                        :label="item.value"
                        name="studentSatus"
                    >{{ item.label }}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>









            
        </el-form>

        <!-- 选择人群弹窗 -->
        <selectPeople v-if="selectPeopleShow" :dialogVisible="selectPeopleShow" :peopleList="peopleList" @confim="selectPeopleSure" @close="selectPeopleShow = false"></selectPeople>
        <!-- 指定/排除商品 -->
        <selectGoodsMonitor
            ref="selectGoFilter"
            v-if="isShowGoods"
            :isShow="isShowGoods"
            @close="selectGoodsCloseFilter"
            :selectGoods="orderWareList"
            :moduleType="true"
            :skuSearch="true"
            :isLimit="true"
            :limitNum="100"
            :disabled="disabled"
            >
        </selectGoodsMonitor>
    </div>
</template>
<script>
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import selectPeople from "@/components/select-people-yunqi.vue";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
export default {
    components: {
        selectPeople,
        selectGoodsMonitor
    },
    model: {
        prop: "ruleForm",
        event: "ruleFormUpdate",
    },
    props: {
        isDisableCond: {
            type: Boolean,
            default: false,
        },
        activityId: {
            type: Number,
            default: 0,
        },
        needNonMember: {
            type: Boolean,
            default: true,
        },
        disabled: { //整体禁用
            type: Boolean,
            default: false,
        },
        localStepNum: {
            type: Number,
            default: null
        },
        plusObjectDistype: { //会员身份禁用
            type: Boolean,
            default: false,
        },
        defaultActivityStartTime:{
            type: String,
            default: "",
        },
        defaultActivityEndTime:{
            type: String,
            default: "",
        },
        ruleForm: {
            type: Object, //
            default: {
                condFollow: false,
                openCardFollow: false,
                isValidBlackList: false,
                startTime: "",
                endTime: "",
                activityName: "",
                openCardBeforeDay: '', // 参与活动前多少天入会
                firstOpenCardTimeType: 0,
                partner: [],
                ruleDTO: {
                    // plusObject: 0,
                    // cusType: 0,
                    openCardEndTime: '',
                    // isCheckOpenCardTime: false,
                    openCardStartTime: '',
                }
            },
        },
        defaultActMember:{
            type: String,
            default: "",
        },
        isNeedCusType:{
            type: Boolean,
            default: false,
        },
        peopleSelected:{
            type: Array,
            default: [],
        },
        plusObject:{ // plus会员身份
            type: Number,
            default:0,
        },
        cusType:{ //新老客户
            type: Number,
            default:0,
        },
        isCheckOpenCardTime:{ //是否指定入会时间
            type: Boolean,
            default: false,
        },
        openCardStartTime:{ //入会开始时间
            type: String,
            default: "",
        },
        openCardEndTime:{ //入会结束时间
            type: String,
            default: "",
        },
        isShowCondFollow:{ // 是否显示关注店铺条件
            type: Boolean,
            default: true,
        },
        isShowBlack:{ // 是否显示单独屏蔽黑名单
            type: Boolean,
            default: false,
        },
        isShowCondTarget:{ // 是否显示活动对象
            type: Boolean,
            default: true,
        },
        isShowActivityTimeSlot:{ // 是否自定义活动时间内容
            type: Boolean,
            default: false,
        },
        isShowParterRadio:{ // 是否显示活动对象
            type: Boolean,
            default: true,
        },
        // 进行中是否可以修改活动名称/活动时间
        isEdit:{
            type: Boolean,
            default: false,
        },
        //特殊入会有礼
        isEdits:{ // 是否显示基本信息
            type: Boolean,
            default: true,
        },
        basicInformation:{ // 是否显示基本信息
            type: Boolean,
            default: true,
        },
        // 对象额外提示占位
        objExtraTip: {
            type: String,
            default: "",
        },
        // 指定/排除商品
        newOrderWareList: {
            type: Array,
            default: [],
        },
        // 自定义JSON字段
        customerPaperwork: {
            type: Object,
            default: () => ({}),
        },
        // 是否禁用人群提示文案
        isCrowdTextDisabled: {
            type: Boolean,
            default: false,
        },
        // 是否显示人群提示文案
        isShowCrowdTips: {
            type: Boolean,
            default: true,
        },
        isShowStudentSet: {
            type: Boolean,
            default: false,
        }
    },
    watch: {
        defaultActMember: {
            immediate: true,
            handler(newValue, oldVal) {
                this.actMember = newValue
            },
        },
        // 监听结束时间变化
        activityEndTime: {
            handler(newValue, oldVal) {
                if (!newValue) return;
                const now = new Date();
                const endTime = new Date(newValue);
                // 判断是否为当天
                const isSameDay = endTime.getFullYear() === now.getFullYear() &&
                                 endTime.getMonth() === now.getMonth() &&
                                 endTime.getDate() === now.getDate();
               if(!isSameDay){
                 this.pickerOptionsValueEnd.selectableRange = `00:00:00 - 23:59:59`;
                }else{
                    // 获取当前时间
                    const now = new Date();
            
                    // 计算当前时间一小时后
                    const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);
                    const timeStr = oneHourLater.toTimeString().substring(0, 8);
            
                    // 更新结束时间选择器的时分秒范围
                    // 注意：由于Element UI的限制，这个更新可能不会立即生效
                    // 需要用户重新打开日期选择器
                    this.pickerOptionsValueEnd.selectableRange = `${timeStr} - 23:59:59`;
              }
            },
        },
        defaultActivityStartTime: {
            immediate: true,
            handler(newValue, oldVal) {
                this.activityStartTime = newValue
                this.activityTimeChange()
            },
        },
        defaultActivityEndTime: {
            immediate: true,
            handler(newValue, oldVal) {
                this.activityEndTime = newValue
                this.activityTimeChange()
            },
        },
        plusObject:{ //Plus会员身份
            immediate: true,
            handler(newValue, oldVal) {
                this.ruleDTOPlusObject = newValue
            },
        },
        cusType:{
            immediate: true,
            handler(newValue, oldVal) {
                this.ruleDTOCusType = newValue
            },
        },
        isCheckOpenCardTime:{
            immediate: true,
            handler(newValue, oldVal) {
                this.ruleDTOIsCheckOpenCardTime = newValue
            },
        },
        openCardStartTime:{
            immediate: true,
            handler(newValue, oldVal) {
                this.ruleDTOOpenCardStartTime = newValue
            },
        },
        openCardEndTime:{
            immediate: true,
            handler(newValue, oldVal) {
                this.ruleDTOOpenCardEndTime = newValue
            },
        },
        newOrderWareList: {
            immediate: true,
            handler(newValue, oldVal) {
                this.orderWareList = newValue
            },
        },
        orderWareList(val) {
            this.$emit('update:newOrderWareList',val)
        },
        actMember(val){
            this.$emit('update:defaultActMember',val)
        },
        ruleDTOPlusObject(val){
            this.$emit('update:plusObject',val)
        },
        ruleDTOCusType(val){
            this.$emit('update:cusType',val)
        },
        ruleDTOIsCheckOpenCardTime(val){
            this.$emit('update:isCheckOpenCardTime',val)
        },
        ruleDTOOpenCardStartTime(val){
            this.$emit('update:openCardStartTime',val)
        },
        ruleDTOOpenCardEndTime(val){
            this.$emit('update:openCardEndTime',val)
        },
        "ruleFormData.firstOpenCardTimeType":{
            immediate: true,
            handler(newValue, oldVal) {
               if(newValue == 0){
                    this.ruleFormData.openCardBeforeDay = '';
                    this.ruleDTOOpenCardStartTime = '';
                    this.ruleDTOOpenCardEndTime = '';
               }else if(newValue == 1){
                    this.ruleDTOOpenCardStartTime = '';
                    this.ruleDTOOpenCardEndTime = '';
               }else if(newValue == 2){
                    this.ruleFormData.openCardBeforeDay = '';
               }
            },
        },
        "ruleFormData.lastOrderCompleteTimeType":{
            immediate: true,
            handler(newValue, oldVal) {
               if(newValue == 0){
                    this.$set(this.ruleFormData, 'lastOrderCompleteStartDay', '');
                    this.$set(this.ruleFormData, 'lastOrderCompleteEndDay', '');
                    this.$set(this.ruleFormData, 'lastOrderCompleteStartTime', '');
                    this.$set(this.ruleFormData, 'lastOrderCompleteEndTime', '');
               }else if(newValue == 1){
                    this.$set(this.ruleFormData, 'lastOrderCompleteStartTime', '');
                    this.$set(this.ruleFormData, 'lastOrderCompleteEndTime', '');
               }else if(newValue == 2){
                    this.$set(this.ruleFormData, 'lastOrderCompleteStartDay', '');
                    this.$set(this.ruleFormData, 'lastOrderCompleteEndDay', '');
               }
            },
        },
        ruleFormData: {
            handler(newValue, oldVal) {
                if(this.activityId== 46&&this.ruleDTOCusType==3) {
                    if(newValue.orderCondition) {
                        this.$set(this.ruleFormData, "orderCondition", newValue.orderCondition);
                    } else {
                        this.$set(this.ruleFormData, "orderCondition", {
                            isSelectLastPayTime: false,
                            isSelectOrder: false,
                            lastPayStartTime: '',
                            lastPayEndTime: '',
                            orderStartTime: '',
                            orderEndTime: '',
                            skuType: 0,
                            skuIds: [],
                            minOrderAmt: "",
                            minItemCnt: "",
                            orderType: 0,
                        });
                    }
                }
            },
            immediate: true,
            deep: true,
        },
        customerPaperwork: {
            handler(newValue, oldVal) {
                this.crowdTipMainText = newValue.crowdTipMainText || "";
                this.crowdTipSubText = newValue.crowdTipSubText || "";
            },
            immediate: true,
            deep: true,
        },
    },
    data() {
        return {
            crowdTipMainText: "",
            crowdTipSubText: "",
            isShowGoods: false,
            appointOptions: [
                {
                value: 1,
                label: "仅排除指定商品的商品件数及金额",
                },
                {
                value: 0,
                label: "只要订单包含指定商品就整单排除",
                },
            ],
            orderWareList: [],
            ruleDTOOpenCardStartTime:"",
            ruleDTOOpenCardEndTime:"",
            ruleDTOIsCheckOpenCardTime:false,
            ruleDTOCusType:0,
            ruleDTOPlusObject:0,
            levelList: [],
            studentStatusList: [
                { value: '1', label: '京东学生用户' },
                { value: '2', label: '领取PLUS校园卡用户' },
                { value: '3', label: '领取滴滴学生卡' },
            ],
            studentSet: 0,
            selectPeopleShow: false,
            peopleList: [],
            // peopleSelected: [],
            isShowTip: false,
            activityStartTime: '',
            activityEndTime: '',
            timeDay: 0,
            timeOut: 0,
            actMember: '1',
            isShowUserCondition: true,
            diaAbleOpenCardFollow: false,
            isShowShopCondition: true,
            isShopConditionExpanded: false,
            isOrderExpanded: false,
            showOpenCardTip: false,
            // ruleFormData: {
            //     condFollow: false,
            //     startTime: "",
            //     endTime: "",
            //     activityName: "",
            //     partner: [],
            //     ruleDTO: {
            //         plusObject: 0,
            //         cusType: 0,
            //         openCardEndTime: '',
            //         isCheckOpenCardTime: false,
            //         openCardStartTime: '',
            //     }
            // },
            pickerOptionsValue: {
                disabledDate: (time) => {
                    if (this.ruleFormData.endTime) {
                        return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleFormData.endTime).valueOf()
                    } else {
                        return time.getTime() < Date.now() - 8.64e7
                    }
                },
            },
            pickerOptionsValueEnd: {
                disabledDate: (time) => {
                    if (this.ruleFormData.startTime) {
                        return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.ruleFormData.startTime).valueOf() - 8.64e7 
                    } else {
                        return time.getTime() < Date.now() - 8.64e7
                    }
                },
                // 当天的时分秒必须大于等于当前时间一小时后，超过当天的不限制
                // 注意：Element UI的selectableRange不支持动态函数，这里使用默认值
                // 实际限制通过watch和验证实现
                selectableRange: "00:00:00 - 23:59:59",
            },
            openCardEndTimeOptionsValue: {
                disabledDate: (time) => {
                    return time.getTime() < new Date(this.ruleDTOOpenCardStartTime).valueOf();
                },
            },
            lastOrderCompleteEndTimeOptionsValue: {
                disabledDate: (time) => {
                    if (this.ruleFormData.lastOrderCompleteStartTime) {
                        return time.getTime() < new Date(this.ruleFormData.lastOrderCompleteStartTime).valueOf();
                    }
                    return false;
                },
            },
            startPayPicker: {
                disabledDate: (time) => {
                    if (this.ruleFormData.orderCondition.lastPayEndTime) {
                        return time.getTime() > new Date(this.ruleFormData.orderCondition.lastPayEndTime).valueOf() || time.getTime() > new Date(this.ruleFormData.endTime).valueOf();
                    }
                },
            },
            endpayPicker: {
                disabledDate: (time) => {
                    if (this.ruleFormData.endTime) {
                        return time.getTime() < new Date(this.ruleFormData.orderCondition.lastPayStartTime).valueOf()-8.64e7 || time.getTime() > new Date(this.ruleFormData.endTime).valueOf();
                    }
                },
            },
            startOrderPicker: {
                disabledDate: (time) => {
                    if (this.ruleFormData.orderCondition.orderEndTime) {
                        return time.getTime() > new Date(this.ruleFormData.orderCondition.orderEndTime).valueOf() || time.getTime() > new Date(this.ruleFormData.endTime).valueOf();
                    }
                },
            },
            endOrderPicker: {
                disabledDate: (time) => {
                    if (this.ruleFormData.endTime) {
                        return time.getTime() < new Date(this.ruleFormData.orderCondition.orderStartTime).valueOf()-8.64e7 || time.getTime() > new Date(this.ruleFormData.endTime).valueOf();
                    }
                },
            },
        }
    },
    computed: {
        ruleFormData: {
            get: function () {
                return this.ruleForm;
            },
            set: function (val) {
                this.$emit("ruleFormUpdate", val);
            },
        },
        studentSatusArr: {
            get() {
                const raw = this.ruleFormData.studentSatus;
                if (Array.isArray(raw)) return raw;
                if (typeof raw === 'string' && raw !== '') return raw.split(',');
                return [];
            },
            set(val) {
                const arr = Array.isArray(val) ? val : [];
                this.$set(this.ruleFormData, 'studentSatus', arr.join(','));
                if (arr.length > 0) {
                    this.studentSet = 0;
                }
            },
        },
        actTypes() {
            // 购物条件活动集合（仅以下活动在 actMember=='2' 指定身份 时显示购物条件）
            // 已隐藏：积分兑换全部(9)、BI店铺礼包(63)、拼团砍价(69)、购物车锦鲤(77)、
            // 盖楼有礼(79)、小红书晒单礼(80)、集分冲榜(81)、粉丝集分应援(82)、
            // 日历打卡(84)、百变趣答(85)、答题导购(87)、积分兑换优惠券(89)
            const list = [46, 68, 78, 83, 86]
            return list.indexOf(this.activityId) != -1
        }
    },
    created() { },
    mounted() {
        // if(this.defaultActivityStartTime||this.defaultActivityEndTime){
        //     this.activityStartTime = this.defaultActivityStartTime
        //     this.activityEndTime = this.defaultActivityEndTime
        //     this.activityTimeChange()
        // }
        // if(this.defaultActMember){
        //     this.actMember = this.defaultActMember
        // }
        this.getLevel()
        this.initStudentStatus()
        if([17, 18, 46, 39, 36, 52, 53, 45, 68, 69,70,78,80,82,83,84,85,86].includes(this.activityId)){
            this.ruleForm.openCardFollow = 1;
            this.diaAbleOpenCardFollow = true;
        }
        const activityTypes = [17,18,46,68,69,70,77,78,80,81,82,83,84,85,86]
        // 首单, 复购, 满额
        if(activityTypes.includes(this.activityId)){
            this.showOpenCardTip = true;
        }
    },
    methods: {
        handlCorwdTips(e, key) {
            let obj = this.customerPaperwork;
            obj[key] = e;
            this.$emit("handlCorwdTips", obj);
        },
        // 打开黑名单管理页面
        openBlackListPage() {
            window.open('/manage/share_polite?tab=interactive', '_blank');
        },
        initStudentStatus() {
            const raw = this.ruleFormData.studentSatus;
            if (raw === undefined || raw === null) {
                this.$set(this.ruleFormData, 'studentSatus', '');
            }
            const hasNoSatus = !raw || (typeof raw === 'string' && raw.trim() === '') || (Array.isArray(raw) && raw.length === 0);
            this.studentSet = hasNoSatus ? 1 : 0;
        },
        onStudentSetChange(val) {
            if (val == 1) {
                this.ruleFormData.studentSatus = '';
            } else {
                // 不限不允许手动取消勾选，恢复为选中状态
                this.$nextTick(() => {
                    this.studentSet = 1;
                });
            }
        },
        changeCusType(val) {
            if(this.activityId== 46&&this.ruleDTOCusType==3) {
                this.ruleFormData.orderCondition.isSelectLastPayTime = false
                this.ruleFormData.orderCondition.isSelectOrder = false
                this.ruleFormData.orderCondition.lastPayStartTime = ""
                this.ruleFormData.orderCondition.lastPayEndTime = ""
                this.ruleFormData.orderCondition.orderStartTime = ""
                this.ruleFormData.orderCondition.orderEndTime = ""
                this.ruleFormData.orderCondition.skuType = 0
                this.ruleFormData.orderCondition.skuIds =[]
                this.ruleFormData.orderCondition.minOrderAmt = ""
                this.ruleFormData.orderCondition.minItemCnt = ""
                this.ruleFormData.orderCondition.orderType = 0
            }
        },
        //选择指定商品回调
        selectGoodsCloseFilter(data) {
            if (data) {
                this.ruleFormData.orderCondition.skuIds = [];
                this.orderWareList = [];
                data.forEach((value, index) => {
                let fomeVaule = {};
                fomeVaule.skuId = data[index].skuId;
                fomeVaule.logo = data[index].logo;
                fomeVaule.price = data[index].jdPrice || data[index].price;
                fomeVaule.title = data[index].wareTitle || data[index].title;
                this.orderWareList.push(fomeVaule);
                this.ruleFormData.orderCondition.skuIds.push(fomeVaule.skuId);
                });
            }
            this.isShowGoods = false;
        },
        handleOpenOldOrderWare() {
            this.isShowGoods = true;
            this.$refs.selectGoFilter.handleRightCurrentChange(1);
        },
        handleInput(val) {
            let value = val;
            if (!value) return;
            // 移除所有非数字和非小数点字符
            value = value.replace(/[^\d.]/g, "");
            // 处理多个小数点，只保留第一个
            value = value.replace(/\.(?=.*\.)/g, "");
            // 限制小数点后两位
            value = value.replace(/^(\d+)\.(\d{0,2}).*/, "$1.$2");
            // 处理前导零：多个零只保留一个，零后跟小数点则保留
            value = value.replace(/^0+(?=0\.|\d)/, "");
            return value;
        },
        formatOrderAmount(e) {
            let value = e.target.value;
            // 如果只输入了0，则清空
            if (value === "0") {
                value = "";
            }
            return value;
        },
        // 给个回调给父组件调用处理业务
        changeActMember(val) {
            this.crowdTipMainText = "";
            this.crowdTipSubText = "";
            this.ruleDTOCusType = 0;
            this.ruleFormData.partner = ["-1"]
            this.ruleFormData.firstOpenCardTimeType = 0;
            this.ruleFormData.openCardBeforeDay = ""
            this.ruleDTOOpenCardStartTime = ""
            this.ruleDTOOpenCardEndTime = ""
            this.peopleSelected = []
            this.$emit('update:peopleSelected',this.peopleSelected)
            if(this.activityId!= 63) {
                this.ruleDTOPlusObject = 0
            }
            if(this.isShowShopCondition) {
                this.ruleFormData.orderCompleteLimitCount = ""
                this.ruleFormData.orderCompleteMaxCount = ""
                this.ruleFormData.orderCompleteLimitPayment = ""
                this.ruleFormData.orderCompleteMaxPayment = ""
                this.ruleFormData.lastOrderCompleteTimeType = 0
                this.ruleFormData.lastOrderCompleteStartDay = ""
                this.ruleFormData.lastOrderCompleteEndDay = ""
                this.ruleFormData.lastOrderCompleteStartTime = ""
                this.ruleFormData.lastOrderCompleteEndTime = ""
            }
            if(this.activityId== 46&&this.ruleDTOCusType==3) {
                this.changeCusType()
            }
      
            this.$emit("getMemberFn",val)
        },
        // 选择人群关闭
        selectPeopleSure(val) {
            // 进行中的活动不支持修改人群，仅允许查看
            if (this.disabled) {
                this.$message.warning('进行中的活动不支持修改，只能查看')
                this.selectPeopleShow = true
                return
            }
            console.log(val,'66666');
            this.$emit('update:peopleSelected',val)
            // this.peopleSelected = val.map(item => item.id)
            this.$emit('selectPeopleSure',val)
            this.selectPeopleShow = false
        },
        //会员等级
        getLevel() {
            querymemberLevel()
                .then((res) => {
                    res.data.forEach((item) => {
                        this.levelList.push(item.customerLevelName);
                    });
                })
                .catch((res) => { });
        },
        //选中改变
        checkListchange(val) {
            if (val[val.length - 1] == "-1" || this.ruleFormData.partner.length == 0) {
                this.ruleFormData.partner = ["-1"];
            } else {
                this.ruleFormData.partner= val.filter((item) => item != "-1");
            }
            this.$emit('checkLevelChangeBack',val)
            // if(val.length > 0){
            //     if(val[val.length - 1] == '-1'){
            //         this.ruleFormData.partner = ["-1"];
            //     }else{
            //         this.ruleFormData.partner = this.ruleFormData.partner.filter(item => item != '-1')
            //     }
            // }
            // val.forEach((low) => {
            //     if (low == -1) {
            //         this.ruleFormData.partner = ["-1"];
            //     }
            // });
        },
        clearNewTime() {
            this.ruleFormData.ruleDTO.openCardStartTime = "";
            this.ruleFormData.ruleDTO.openCardEndTime = "";
        },
        clearOrderFinishTime() {
            this.ruleFormData.lastOrderCompleteStartTime = "";
            this.ruleFormData.lastOrderCompleteEndTime = "";
        },
        openCrowd() {
            this.peopleList = this.peopleSelected.map(item => {
                return { id: item }
            })
            this.selectPeopleShow = true
            this.actMember = "3"
        },
        // 点击下单时间显示提示，同时动态设置时分秒选择范围
        orderFocus() {
            if (this.disabled) {
                this.isShowTip = true
            }
            
            // 获取当前时间
            const now = new Date();
            
            
            // 计算当前时间一小时后
            const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);
            const timeStr = oneHourLater.toTimeString().substring(0, 8);
            
            
            // 更新结束时间选择器的时分秒范围
            // 注意：由于Element UI的限制，这个更新可能不会立即生效
            // 需要用户重新打开日期选择器
            this.pickerOptionsValueEnd.selectableRange = `${timeStr} - 23:59:59`;
        },
        // 活动时间改变
        activityTimeChange() {
            this.$nextTick(()=>{
                this.$emit("activityTimeChange")
            })
            if(!this.activityStartTime || !this.activityEndTime) return;
            this.ruleFormData.startTime = this.activityStartTime;
            this.ruleFormData.endTime = this.activityEndTime;
            this.$emit('update:defaultActivityStartTime',this.activityStartTime)
            this.$emit('update:defaultActivityEndTime',this.activityEndTime)
            this.$nextTick(() => {
                if (this.ruleFormData.endTime && this.ruleFormData.startTime) {
                    let nowTime = new Date().getTime();
                    let start = new Date(this.ruleFormData.startTime).valueOf();
                    let end = new Date(this.ruleFormData.endTime).valueOf();
                    let invalidateDate = new Date(this.$store.getters.pointUserInfo.expiredIn).valueOf();
                    let hdInvalidateDate = new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf();
                    this.timeDay = Math.floor(
                        Math.abs(
                            new Date(this.ruleFormData.endTime) -
                            new Date(this.ruleFormData.startTime)
                        ) /
                        1000 /
                        60 /
                        60 /
                        24
                    );
                    //计算小时
                    const date3 = new Date(this.ruleFormData.endTime).getTime() - new Date(this.ruleFormData.startTime).getTime();
                    const leave1 = date3 % (24 * 3600 * 1000);
                    this.timeOut = Math.floor(leave1 / (3600 * 1000));
                    const parentData = this.$parent.$parent;
                    let backgroundOpacity = false;
                    backgroundOpacity = parentData.backgroundOpacity;
                    
                    //时间校验
                   const timeDiff = Math.abs(new Date(this.ruleFormData.endTime) - new Date(this.ruleFormData.startTime));
                   this.timeDay = Math.floor(timeDiff / 1000 / 60 / 60 / 24);
                   const timeHour = Math.floor(timeDiff / 1000 / 60 / 60);


                    if (timeHour < 1 && !this.backgroundOpacity) {
                        this.$message.warning("活动开始时间和结束时间间隔必须大于1小时！");
                        // this.activityTimeValue[1] = "";
                        this.activityEndTime = null;
                        this.ruleFormData.endTime = null;
                        this.timeOut = 0
                        this.timeDay = 0
                        // this.activityTimeValue = []
                        return;
                    }

                    // 查看不需要校验
                    if (!backgroundOpacity) {
                        if (start < nowTime) {
                            if (this.ids) {
                                this.disableTime = true;
                            } else {
                            }
                        }
                        if (end < nowTime) {
                            this.$message.warning("结束时间不能小于当前时间");
                        }
                        if (end < start) {
                            this.$message.warning("结束时间不能小于开始时间");
                            return;
                        }
                        if (end > invalidateDate) {
                            this.$message.warning("活动时间不能超过软件有效期，请重新选择");
                            this.activityEndTime = null;
                            this.ruleFormData.endTime = null;
                            return;
                        }
                        if (end > hdInvalidateDate) {
                            this.$message.warning("活动时间不可超过互动数据授权有效期！");
                            this.activityEndTime = null;
                            this.ruleFormData.endTime = null;
                            return;
                        }
                    }
                }
            });
        },
        // 清空时间
        clearTime() {
            this.ruleFormData.startTime = "";
            this.ruleFormData.endTime = "";
            this.activityStartTime = null
            this.activityEndTime = null
        },
        getCustomerTip () {
            let tip = "注：由于接口限制，未入会用户需先入会方可参与活动"
            let id = this.activityId
            if([17, 18, 46, 39, 36, 52, 53, 45].includes(id)){
                // tip = "注：由于接口限制，未入会用户需先入会方可参与活动，不可单选【非会员】"
                return "注：由于接口限制，未入会用户需先入会方可参与活动；为避免用户入会后不可参与活动造成客诉，请合理设置会员等级"; // 1.44(润兰改)

            } else {
                return "";
            }
            return tip;
        },
        handleLastPayTimeChange() {
            this.ruleFormData.orderCondition.lastPayStartTime = ""
            this.ruleFormData.orderCondition.lastPayEndTime = ""
        },
        handleOrderChange() {
            this.ruleFormData.orderCondition.orderStartTime = ""
            this.ruleFormData.orderCondition.orderEndTime = ""
            this.ruleFormData.orderCondition.skuType = 0
            this.ruleFormData.orderCondition.skuIds =[]
            this.ruleFormData.orderCondition.minOrderAmt = ""
            this.ruleFormData.orderCondition.minItemCnt = ""
            this.ruleFormData.orderCondition.orderType = 0
        }
    }
}
</script>
<style lang="scss" scoped>
.user_condition{
    width: 1100px;
    background: #fafafa;
    padding-left: 4px;
    font-weight: 600;
    margin-top: 4px;
}
.rule_box {
    // width: 860px;
    width: 1100px;
    // height: 217px;
    margin-top: 0px;
    background: #fafafa;
    padding-bottom: 10px;
    border-radius: 4px;
    font-size: 14px;

    &_middle {
        padding-top: 10px;
    }

    &_content {
        padding: 0 15px;

        img {
            display: inline-block;
            float: left;
            position: absolute;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 9px 4px 0 3px;
        }

        p {
            padding-left: 21px;
        }
    }
}

/* 条件标题区域 */
.condition-header {
    width: 1100px;
    background: #fafafa;
    padding-left: 4px;
    font-weight: 600;
}

.condition-title {
  font-weight: 600;
  color: #000;
}

.toggle-btn {
  margin-left: 8px;
}

/* 订单笔数 */
.order-count-section {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.order-input {
  width: 100px;
}

/* 订单金额 */
.order-amount-section {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

/* 最后订单时间 */
.last-order-time-section {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}


.shopLabel {
  display: flex;
  width: 180px;
  padding-right: 8px;
  padding-left: 8px;
  align-items: center;
  justify-content: end;
}

.order-input {
  width: 100px;
}

.ml8-mr8 {
  margin-left: 8px;
  margin-right: 8px;
}

/* 最后订单时间 */
.last-order-time-section {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}


.day-input {
    width: 80px;
}
.shopContainer {
    background: #fafafa;
    width: 1100px;
    padding: 10px 0;
}
.ml-100 {
    margin-left: 100px;
}
.ml-60 {
    margin-left: 60px;
}
.ml-60 {
    margin-left: 60px;
}
.formTitle {
    width: 100px;
    text-align: right;
}

.mr4 {
    margin-right: 4px;
}

.extra-tip {
    font-size: 12px;
    color: #FF4D4F;
}
.old-greyBg-overflow {
    padding: 16px 0;
    border-radius: 4px;

    .old-greyBg {
      padding: 16px;
      margin-top: 4px;
      background: #fff;
      border-radius: 4px;
      color: #666;
      font-size: 12px;
      border: 1px solid #dcdfe6;
      width: fit-content;
      min-width: 818px;
    }

    .tip-style {
      margin-left: 8px;
      color: #f59f71;
    }

    .goods-tip {
      margin-left: 8px;
      color: #666;
    }

    .ml8 {
      margin-left: 8px;
    }

    .mr8 {
      margin-right: 8px;
    }
    .mlr8 {
      margin-left: 8px;
      margin-right: 8px;
    }
  }

  ::v-deep .crowd-tip-main .el-input__inner::placeholder,
  ::v-deep .crowd-tip-main .el-input__inner::-webkit-input-placeholder {
    color: #333 !important;
  }
</style>